module.exports = __webpack_public_path__ + "static/media/1-godt.1080d169.mp3";